// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__1hyKw","title":"Images45_title__2X82-","images":"Images45_images__2ow72"};